<script>
import Instafeed from 'instafeed.js'
import { mapGetters } from 'vuex'
export default
{
    name: 'insta-feed',

    computed: mapGetters(['channel']),

    data()
    {
        return {
            feed: null,
            id: 'instaFeedLoverly-' + this._uid
        }
    },

    created()
    {
        this.feed = new Instafeed({
            get: 'user',
            target: this.id,
            userId: this.channel.instagram_id,
            resolution: 'standard_resolution',
            limit:2,
            template: `<div class="col-12 col-sm-6">
                <div class="insta-item">
                    <a href="{{link}}" target="_blank">
                        <div class="insta-item-picture" style="background-image:url(\'{{image}}\')"></div>
                        <div class="insta-item-footer">
                            <i class="fal fa-heart fa-2x"></i>
                            <i class="fal fa-comment fa-2x"></i>
                            <span class="likes">
                                <i class="fa fa-heart"></i>
                                {{likes}} likes
                            </span>
                        </div>
                    </a>
                </div>
            </div>`
            ,
            accessToken: this.channel.instagram_token,
            }).run()

    },
}
</script>

<template>
<div ref="feed" :id="id" class="row">

</div>
</template>




// WEBPACK FOOTER //
// src/components/elements/IntsaFeed.vue